import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PricingPlan } from 'types';
import { paymentsApiSlice } from 'services/payments';


interface PaymentsState {
    currentPricingPlan: PricingPlan | null;
    upcomingPricingPlan: PricingPlan | null;
}


const initialState: PaymentsState = {
    currentPricingPlan: null,
    upcomingPricingPlan: null,
};

export const paymentsSlice = createSlice({
    name: 'payments',
    initialState,
    reducers: {
        setPricingPlan: (state, action: PayloadAction<PricingPlan | null>) => {
            state.currentPricingPlan = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
        .addMatcher(paymentsApiSlice.endpoints.selectPricingPlan.matchFulfilled, (state, { payload }) => {
            state.currentPricingPlan = payload.subscription.pricing_plan as PricingPlan;
        }
        )
        .addMatcher(paymentsApiSlice.endpoints.changePricingPlan.matchFulfilled, (state, { payload }) => {
            if (payload.immediately) {
                state.currentPricingPlan = payload.subscription.pricing_plan as PricingPlan;
                state.upcomingPricingPlan = null;
            } else {
                state.currentPricingPlan = payload.subscription.pricing_plan as PricingPlan;
                state.upcomingPricingPlan = payload.new_subscription.pricing_plan as PricingPlan;
            }
        }
        )
        .addMatcher(paymentsApiSlice.endpoints.cancelSubscription.matchFulfilled, (state, { payload }) => {
            if (payload.immediately) {
                state.currentPricingPlan = null;
                state.upcomingPricingPlan = null;
            } else {
                state.currentPricingPlan = payload.subscription.pricing_plan as PricingPlan;
                state.upcomingPricingPlan = null;
            }
        }
        );  
    },
});

export const { setPricingPlan } = paymentsSlice.actions;

export default paymentsSlice.reducer;